export default __webpack_public_path__ + "1aeaa2dc6c70a770b4f2dc24db205597.png";